var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8389 0C16.2344 4.01632e-06 16.5555 0.321318 16.5557 0.716797V12.2451C16.5557 12.6407 16.2345 12.9619 15.8389 12.9619H8.99414V14.8877H13.25C14.2051 14.8877 14.2051 16.3203 13.25 16.3203H3.30566C2.35096 16.32 2.35096 14.888 3.30566 14.8877H7.56152V12.9619H0.716797C0.321316 12.9617 0 12.6406 0 12.2451V0.716797C0.000164232 0.321417 0.321417 0.000164232 0.716797 0H15.8389ZM1.43262 11.5293H15.1221L15.123 9.49609H1.43262V11.5293ZM1.43262 8.06348H15.1221V1.43262H1.43262V8.06348Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.ad20e26d0c5528ce06337fb0434192f7.svg";
export { ForwardRef as ReactComponent };